// (function () {
//     'use strict';

//     angular.module("imApp").factory("travelBillLogService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getMenu: function (parms) {
//                 return $ihttp.post({
//                     method: 1722,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
